import React, { useCallback, useEffect, useRef, useState } from 'react'
import { DatePicker, Divider, Radio, Spin } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep, debounce, isEmpty, isEqual } from 'lodash';
import dayjs from "dayjs";
import { useParams } from 'react-router-dom';

import ReactSelect from '../../../../../../components/uiComponent/select';
import Button from "../../../../../../components/uiComponent/button/index";
import Input from "../../../../../../components/uiComponent/inputs/input/index"

import { StepThreeWrapper } from '../style';
import {
  ListTransportationOptions,
  ListDeliveryWindowOptions,
  ConfirmTransportationOptions,
  ConfirmDeliveryWindowOption,
  UpdateShipmentTrackingDetails,
  GetWarehouseShipments,
  SaveTransportationDetails
} from '../../../../../../slices/post-shipment';

const StepThree = ({ 
  showTransportGlobal,
  setActiveKey, 
  shipmentIdOuter, 
  setTransportationDetails, 
  transportationDetails,
  updateShipmentTrackingDetailsLoading,
  deliveryWindowOptionsLoading
}) => {
  const dispatch = useDispatch();
  const { workOrderId } = useParams();

  // const [deliveryWindowOptionsLoading, setDeliveryWindowOptionsLoading] = useState(false);
  // const [updateShipmentTrackingDetailsLoading, setUpdateShipmentTrackingDetailsLoading] = useState(false);
  const [selectedPCOptions, setSelectedPCOptions] = useState([])
  const [partneredCarrierValue, setPartneredCarrierValue] = useState([])
  const [pickupDate, setPickupDate] = useState([]);

  const {
    shipmentDetails,
    fetchingWarehouseShipments,
    transportationOptions,
    listingTransportationOptions,
    deliveryWindowOptions,
    listingDeliveryWindowOptions,
    confirmingDeliveryWindowOption,
    confirmingTransportationOption,
    updatingShipmentTrackingDetails,
    saveTransportationDetailsLoading
  } = useSelector((state) => state.postShipment || {});
  // const [transportationDetails, setTransportationDetails] = useState([]);
  const [triggerAutosave, setTriggerAutosave] = useState(false);

  const { amazonInboundPlanId: inboundPlanId, shipments, contactDetails, placementFee } = shipmentDetails || {};
  const { nonPartneredOptions, partneredOptions } = transportationOptions || {};

  const selectRefs = useRef([]);

  // useEffect(() => {
  //   if (isEmpty(shipmentDetails) || listingTransportationOptions) return;
    
  //   if (shipmentDetails?.inboundStatus === 'TRANSPORTATION_CONFIRMED') return;

  //   const shipmentIds = shipments.map(({ amazon_shipment_id: shipmentId }) => shipmentId) || [];
  //   dispatch(ListDeliveryWindowOptions({ inboundPlanId, shipmentIds }));

  //   dispatch(ListTransportationOptions({
  //     inboundPlanId,
  //     placementOptionId: shipments[0]?.amazon_placement_option_id
  //   }))
  //     .then(() => {
  //       setTransportationDetails(shipmentDetails?.transportationDetails || []);
  //     });
  // }, [shipmentDetails]);

  useEffect(() => {
      setTransportationDetails(shipmentDetails?.transportationDetails || []);
  }, [shipmentDetails]);

  useEffect(() => {
    dispatch(GetWarehouseShipments({
      workOrderId,
    })).then(({ payload }) => {
      if (payload?.success) {
        setTransportationDetails(payload?.shipmentDetails?.transportationDetails || []);
      }
    })

    return () => {
      setTransportationDetails([]);
    }
  }, []);


  useEffect(() => {

    if (Object.keys(transportationOptions).length > 0) {

      shipments.forEach(({ amazon_shipment_id }, index) => {
        let pickupOptions = selectRefs?.current[index]?.getValue();
        if (pickupOptions && pickupOptions.length > 0) {
          setSelectedPCOptions(options => {
            const optionsClone = cloneDeep(options);
            optionsClone[index] = pickupOptions[0]?.value
            return optionsClone;
          })
        }

      })


    }
  }, [transportationOptions, shipments])




  const shippingOptions = [
    { value: "amazon-ltl", label: "Amazon Freight LTL - $128.06" },
    { value: "non-partnered", label: "Non-Partnered Carrier", },
    { value: "non-partneresd", label: "Non-Parstnered Carrier", },
  ];

  // const getConfirmBtnDisabledStatus = () => {
  //   return !transportationDetails?.length || transportationDetails.some(({
  //     transportationOptionId,
  //     deliveryWindowOptionId,
  //     proNumber,
  //   }) => (
  //     !deliveryWindowOptionId ||
  //     (!transportationOptionId?.partnered && !transportationOptionId?.nonPartnered) ||
  //     (transportationOptionId?.nonPartnered && !proNumber)
  //   ));
  // };

  // const handleConfirmShipping = async () => {
  //   setDeliveryWindowOptionsLoading(true);
  //   const requests = transportationDetails.map(({ shipmentId, deliveryWindowOptionId }) =>
  //     dispatch(ConfirmDeliveryWindowOption({
  //       inboundPlanId,
  //       shipmentId,
  //       deliveryWindowOptionId
  //     }))
  //   );

  //   await Promise.all(requests);
  //   setDeliveryWindowOptionsLoading(false);

  //   dispatch(ConfirmTransportationOptions({
  //     inboundPlanId,
  //     transportationSelections: transportationDetails?.map(({ shipmentId, transportationOptionId }) => {
  //       return {
  //         contactInformation: {
  //           email: contactDetails?.email,
  //           name: contactDetails?.name,
  //           phoneNumber: contactDetails?.phone,
  //         },
  //         shipmentId,
  //         transportationOptionId: transportationOptionId?.partnered || transportationOptionId?.nonPartnered
  //       };
  //     }) || []
  //   })).then(async ({ payload }) => {
  //     if (payload?.success) {
  //       setUpdateShipmentTrackingDetailsLoading(true);
  //       const requests = transportationDetails.filter(({ carrierType }) => carrierType === 'non-partnered')
  //         ?.map(({ shipmentId, proNumber }) =>
  //           dispatch(UpdateShipmentTrackingDetails({
  //             inboundPlanId,
  //             shipmentId,
  //             trackingDetails: {
  //               ltlTrackingDetail: {
  //                 freightBillNumber: [proNumber]
  //               }
  //             }
  //           }))
  //         );

  //       await Promise.all(requests);
  //       setUpdateShipmentTrackingDetailsLoading(false);

  //       dispatch(GetWarehouseShipments({
  //         workOrderId,
  //       }));
  //       setActiveKey('4');
  //     }
  //   });
  // };

  // const estimatedShippingFee = transportationDetails?.reduce((sum, option) => {
  //   const obj = partneredOptions?.find?.(({ transportationOptionId }) => transportationOptionId === option?.transportationOptionId?.partnered) || {};
  //   return sum + (obj?.quote?.cost?.amount || 0);
  // }, 0);

  const toSnakeCase = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(toSnakeCase);
    }

    if (obj !== null && typeof obj === 'object') {
      const newObj = {};

      for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        if (key === 'transportationOptionId' && (obj.carrierType || obj.carrier_type)) {
          const carrierType = obj.carrierType || obj.carrier_type;
          if (carrierType === 'partnered') {
            newObj['partnered_id'] = obj.transportationOptionId.partnered;
          } else if (carrierType === 'non-partnered') {
            newObj['non_partnered_id'] = obj.transportationOptionId.nonPartnered;
          }
          continue;
        }

        const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        newObj[snakeKey] = toSnakeCase(obj[key]);
      }

      return newObj;
    }

    return obj;
  };

  // const handleSaveBtn = () => {
  //   const snakeCasedDetails = toSnakeCase(transportationDetails);
  //   dispatch(SaveTransportationDetails(snakeCasedDetails));
  // };

  const prevDetailsRef = useRef();

  const debouncedSave = useCallback(
    debounce((latestDetails) => {
      const snakeCased = toSnakeCase(latestDetails);
      dispatch(SaveTransportationDetails(snakeCased));
    }, 2000), // 2s debounce
    [triggerAutosave]
  );

  useEffect(() => {
    const prev = prevDetailsRef.current;
    if (!prev) {
      prevDetailsRef.current = transportationDetails;
      return;
    }

    if (!isEqual(prev, transportationDetails)) {
      if (!listingTransportationOptions) {
        debouncedSave(transportationDetails);
        prevDetailsRef.current = transportationDetails;
      }
    }

    return () => debouncedSave.cancel();
  }, [triggerAutosave]);

  return (
    <Spin tip='Loading...' spinning={false}>
      <StepThreeWrapper className={`${showTransportGlobal ? 'show-global' : 'hide-global'}`}>
        {!showTransportGlobal ? <>
          <div className='title-labels-wrapper'>
            <div className='items-wrapper'>
              <p>shipment ID</p>
              <p>FBA18MR09</p>
            </div>
            <div className='items-wrapper'>
              <p>Amazon Reference ID</p>
              <p>FBA18MR0984DTY</p>
            </div>
            <div className='items-wrapper'>
              <p>Shipping Mode</p>
              <p className='shipping-mode'>LTL</p>
            </div>
            <div className='items-wrapper'>
              <p>Ship Date</p>
              <p>12/03/24</p>
            </div>
            <div className='items-wrapper'>
              <p>Ship To</p>
              <p>Akshya Nagar 1st Block 1st Cross</p>
            </div>
          </div>
          <div className='career-items-wrapper'>
            <p>Carrier</p>
            <div className='radio-items'>
              <Radio.Group>
                <div className='items-wrapper'>
                  <Radio key={'1'} value={'32'} />
                  <ReactSelect
                    options={shippingOptions}
                    placeholder="Amazon Freight LTL - $128.06"
                  />
                </div>
                <div className='items-wrapper'>
                  <Radio key={'2'} value={'23'} />
                  <ReactSelect
                    options={shippingOptions}
                    placeholder="Non-Partnered Carrier"
                  />
                </div>
                <ReactSelect
                  options={shippingOptions}
                  placeholder="(December 9, 2024  07:00 PM)  -  (December 10, 2024  06:59 PM)"
                />
              </Radio.Group>
            </div>
          </div>
        </> :
          <div className='view-card-global-wrapper'>
            {shipments?.map(({
              amazon_shipment_confirmation_id,
              amazon_reference_id,
              amazon_shipment_id,
              destination_address_line_1: address_line1,
              destination_city: city,
              destination_country_code: country,
              destination_name: name,
              destination_postal_code: postal_code,
              destination_state_or_province_code: state,
            }, index) => {
              if (amazon_shipment_id !== shipmentIdOuter) return null;
              const formattedAddress = `${name} ${address_line1} ${city}, ${state} ${postal_code} ${country}`;
              let amzShipmentOptions = partneredOptions?.filter((option) => option.shipmentId === amazon_shipment_id) || []
              const groupedOptions = amzShipmentOptions.reduce((acc, option) => {
                const carrierName = option?.carrier?.name;
                if (!acc[carrierName]) {
                  acc[carrierName] = [];
                }
                acc[carrierName].push(option);
                return acc;
              }, {});

              const shipmentPartneredOptions = Object.entries(groupedOptions).map(
                ([carrierName, options]) => {
                  const amounts = options.map(opt => opt?.quote?.cost?.amount);
                  const allSame = amounts.every(amount => amount === amounts[0]);

                  const priceLabel = allSame
                    ? `($${amounts[0]})`
                    : `($${Math.min(...amounts)} - $${Math.max(...amounts)})`;

                  const sortedOptions = options.sort(
                    (a, b) =>
                      new Date(a.carrierAppointment?.startTime) -
                      new Date(b.carrierAppointment?.startTime)
                  );

                  return {
                    label: `${carrierName} \n${priceLabel}`,
                    value: sortedOptions.map(opt => ({
                      label: `${dayjs(opt?.carrierAppointment?.startTime).format("MMMM D, YYYY")} \n($${opt?.quote?.cost?.amount})`,
                      value: opt?.transportationOptionId
                    })),
                    minPrice: Math.min(...amounts),
                    transportationOptionIds: groupedOptions[carrierName].map(opt => opt?.transportationOptionId),
                  };
                }
              ).sort((a, b) => a.minPrice - b.minPrice).map(({ minPrice, ...rest }) => rest);

              const shipmentNonPartneredOptions = (nonPartneredOptions?.filter((option) => option.shipmentId === amazon_shipment_id) || [])
                ?.map((option) => ({ value: option.transportationOptionId, label: option.carrier.name }));

              const shipmentDeliveryWindowOptions = [...(deliveryWindowOptions[amazon_shipment_id] || [])]
                // ?.filter(({ startDate, endDate }) => (transportationDetails?.[index]?.carrierType === 'non-partnered') ? (dayjs(endDate).diff(dayjs(startDate), "day") <= 7) : true)
                ?.sort((a, b) => dayjs(a.startDate).valueOf() - dayjs(b.startDate).valueOf())
                ?.map(({ startDate, endDate, deliveryWindowOptionId: value }) => ({ value, label: `${dayjs(startDate).format("MMMM D, YYYY")} - ${dayjs(endDate).format("MMMM D, YYYY")}` }));

              const {
                carrierType,
                transportationOptionId,
                deliveryWindowOptionId,
                proNumber,
              } = transportationDetails[index] || {};

              return (
                <div key={index} className='view-card-global'>
                  {/* <h6>{amazon_shipment_confirmation_id}</h6> */}
                  <div className='inner-content'>
                    {/* <div className='title-labels-wrapper'>
                      <div className='items-wrapper'>
                        <p>Shipment ID</p>
                        <p>{amazon_shipment_confirmation_id}</p>
                      </div>
                      <div className='items-wrapper'>
                        <p>Amazon Reference ID</p>
                        <p>{amazon_reference_id || '---'}</p>
                      </div>
                      <div className='items-wrapper'>
                        <p>Shipping Mode</p>
                        <p className='shipping-mode'>LTL</p>
                      </div>
                      <div className='items-wrapper'>
                        <p>Ship Date</p>
                        <p>{contactDetails?.shipDate}</p>
                      </div>
                      <div className='items-wrapper'>
                        <p>Ship To</p>
                        <p>{formattedAddress}</p>
                      </div>
                    </div> */}
                    <div className='career-items-wrapper'>
                      <div className='items-wrapper'>
                        <span className='item-text-wrapper'>Ship To: </span>
                        <span className='item-text-wrapper'>{formattedAddress}</span>
                      </div>
                      <span style={{ display: 'flex' }}>
                        <p>Carrier Information</p>
                        <p style={{ color: 'red', fontSize: 12 }}>*</p>
                      </span>
                      <div className='radio-items'>
                        <Radio.Group
                          onChange={({ target }) => {
                            setTransportationDetails(transportationDetails => {
                              const transportationDetailsClone = cloneDeep(transportationDetails);
                              transportationDetailsClone[index].carrierType = target?.value;
                              transportationDetailsClone[index].transportationOptionId.partnered = '';
                              transportationDetailsClone[index].transportationOptionId.nonPartnered = '';
                              transportationDetailsClone[index].deliveryWindowOptionId = '';
                              transportationDetailsClone[index].proNumber = '';
                              return transportationDetailsClone;
                            });
                            setTriggerAutosave(prev => !prev);
                          }}
                          value={carrierType}
                        >
                          <div className='items-wrapper'>
                            <Radio
                              key={'partnered'}
                              value={'partnered'}
                              disabled={!listingTransportationOptions && !shipmentPartneredOptions?.length}
                            />
                            <div className='items-wrapper-select'>
                              <ReactSelect
                                menuPlacement='top'
                                ref={(el) => (selectRefs.current[index] = el)}
                                options={listingTransportationOptions ? [] : shipmentPartneredOptions}
                                placeholder='Partnered Carrier'
                                disabled={!listingTransportationOptions && !shipmentPartneredOptions?.length}
                                loading={listingTransportationOptions}
                                value={
                                  listingTransportationOptions
                                    ? ''
                                    : transportationOptionId?.partnered && !!partneredCarrierValue[index]
                                      ? partneredCarrierValue[index]
                                      : shipmentPartneredOptions.find((option) =>
                                        option.value.some((subOption) => subOption.value === transportationOptionId?.partnered)
                                      )
                                }
                                onChange={({ label, value }) => {
                                  setPartneredCarrierValue(carrierValues => {
                                    const carrierValuesClone = cloneDeep(carrierValues);
                                    carrierValuesClone[index] = { label, value };
                                    return carrierValuesClone;
                                  });
                                  if (!pickupDate[index]?.value) {
                                    setPickupDate(pickup => {
                                      const pickupClone = cloneDeep(pickup);
                                      pickupClone[index] = null;
                                      return pickupClone;
                                    });
                                  }
                                  const matchedCarrier = shipmentPartneredOptions.find(
                                    carrier => carrier.label.trim() === label.trim()
                                  );
                                  setPickupDate(pickup => {
                                    const pickupClone = cloneDeep(pickup);
                                    pickupClone[index] = matchedCarrier?.value[0];
                                    return pickupClone;
                                  })
                                  setSelectedPCOptions(options => {
                                    const optionsClone = cloneDeep(options);
                                    optionsClone[index] = value;
                                    return optionsClone;
                                  })
                                  setTransportationDetails(transportationDetails => {
                                    const transportationDetailsClone = cloneDeep(transportationDetails);
                                    transportationDetailsClone[index].carrierType = 'partnered';
                                    transportationDetailsClone[index].transportationOptionId.partnered = matchedCarrier?.transportationOptionIds[0];
                                    transportationDetailsClone[index].transportationOptionId.nonPartnered = '';
                                    transportationDetailsClone[index].deliveryWindowOptionId = '';
                                    transportationDetailsClone[index].proNumber = '';
                                    return transportationDetailsClone;
                                  });
                                  setTriggerAutosave(prev => !prev);
                                }}
                              />
                              {(!listingTransportationOptions && !shipmentPartneredOptions?.length) && <p>Amazon PCP not available</p>}
                            </div>
                          </div>
                          <div className='items-wrapper'>
                            <Radio
                              key={'non-partnered'}
                              value={'non-partnered'}
                            />
                            <div className='items-wrapper-select'>
                              <ReactSelect
                                menuPlacement='top'
                                options={listingTransportationOptions ? [] : shipmentNonPartneredOptions}
                                placeholder='Non-Partnered Carrier'
                                loading={listingTransportationOptions}
                                value={
                                  listingTransportationOptions ? '' :
                                    transportationOptionId?.nonPartnered ?
                                      shipmentNonPartneredOptions.find(option => option.value === transportationOptionId?.nonPartnered)
                                      : null
                                }
                                onChange={({ value }) => {
                                  setTransportationDetails(transportationDetails => {
                                    const transportationDetailsClone = cloneDeep(transportationDetails);
                                    transportationDetailsClone[index].transportationOptionId.nonPartnered = value;
                                    transportationDetailsClone[index].transportationOptionId.partnered = '';
                                    transportationDetailsClone[index].carrierType = 'non-partnered';
                                    transportationDetailsClone[index].deliveryWindowOptionId = '';
                                    return transportationDetailsClone;
                                  });
                                  setTriggerAutosave(prev => !prev);
                                }}
                              />
                            </div>
                          </div>
                        </Radio.Group>
                        <div className='non-radio-fields'>

                          {
                            (carrierType === 'non-partnered') &&
                            <Input
                              placeholder='Enter'
                              label='Pro Number'
                              disabled={transportationOptionId.nonPartnered === ''}
                              value={listingTransportationOptions ? null : proNumber}
                              important={true}
                              onChange={({ target }) => {
                                setTransportationDetails(transportationDetails => {
                                  const transportationDetailsClone = cloneDeep(transportationDetails);
                                  transportationDetailsClone[index].proNumber = target?.value;
                                  return transportationDetailsClone;
                                });
                                setTriggerAutosave(prev => !prev);
                              }}
                            />
                          }
                          {
                            carrierType === 'partnered' &&
                            (
                              <ReactSelect
                                menuPlacement='top'
                                options={selectedPCOptions[index]}
                                label={'Pickup Dates'}
                                placeholder='Select'
                                disabled={(!listingTransportationOptions && !shipmentPartneredOptions?.length ) || transportationOptionId?.partnered === ''}
                                loading={listingTransportationOptions}
                                value={
                                  partneredCarrierValue[index]
                                    ? pickupDate[index]
                                    : (listingTransportationOptions
                                      ? null
                                      : transportationOptionId?.partnered &&
                                      selectedPCOptions[index]?.find(option => option?.value === transportationOptionId?.partnered))
                                }
                                onChange={({ label, value }) => {
                                  setPickupDate(pickup => {
                                    const pickupClone = cloneDeep(pickup);
                                    pickupClone[index] = { label, value };
                                    return pickupClone;
                                  });
                                  setTransportationDetails(transportationDetails => {
                                    const transportationDetailsClone = cloneDeep(transportationDetails);
                                    transportationDetailsClone[index].transportationOptionId.partnered = value;
                                    transportationDetailsClone[index].transportationOptionId.nonPartnered = '';
                                    transportationDetailsClone[index].carrierType = 'partnered';
                                    transportationDetailsClone[index].deliveryWindowOptionId = '';
                                    transportationDetailsClone[index].proNumber = '';

                                    return transportationDetailsClone;
                                  });
                                  setTriggerAutosave(prev => !prev);
                                }}

                              />

                            )
                          }

                          <ReactSelect
                            important={true}
                            menuPlacement='top'
                            label='Select Delivery Window'
                            options={listingTransportationOptions ? [] : shipmentDeliveryWindowOptions}
                            placeholder="(December 9, 2024)  -  (December 10, 2024)"
                            loading={listingDeliveryWindowOptions || listingTransportationOptions}
                            value={listingTransportationOptions ? null : (deliveryWindowOptionId ? shipmentDeliveryWindowOptions.find(option => option.value === deliveryWindowOptionId) : null)}
                            disabled={isEmpty(deliveryWindowOptions) || !carrierType || ((carrierType === 'non-partnered' && !(proNumber)) || (carrierType === 'partnered'  && transportationOptionId?.partnered === '')) }
                            onChange={({ value }) => {
                              setTransportationDetails(transportationDetails => {
                                const transportationDetailsClone = cloneDeep(transportationDetails);
                                transportationDetailsClone[index].deliveryWindowOptionId = value;
                                return transportationDetailsClone;
                              });
                              setTriggerAutosave(prev => !prev);
                            }}
                          />

                        </div>

                        {/* <div className='date-range-wrapper'>
                      <label>Delivery  Date</label>
                      <DatePicker />
                      </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

        }
        {/* <div className='footer'>
          <div className='final-record-items'>
            <div className='items-wrapper'>
              <p className='title-text'>Fees Details</p>
              <div className='content-items-wrapper'>
                <p>Placement Fees:</p>
                <p>${placementFee || 0}</p>
              </div>
              <div className='content-items-wrapper'>
                <p>Estimate Shipping Fees:</p>
                <p>${Number(estimatedShippingFee || 0)?.toFixed(2)}</p>
              </div>
              <Divider />
              <div className='content-items-wrapper final-record'>
                <p>Total Estimated Fees:</p>
                <p>${Number((placementFee || 0) + (estimatedShippingFee || 0))?.toFixed(2)}</p>
              </div>
            </div>
            <div className='buttons-wrapper'>
               <Button
                onClick={handleSaveBtn}
                text="Save"
                className="primary"
                disabled={saveTransportationDetailsLoading}
              />
              <Button
                text="Confirm Shipping"
                disabled={getConfirmBtnDisabledStatus()}
                onClick={handleConfirmShipping}
              />
            </div>
          </div>
        </div>  */}

      </StepThreeWrapper>
    </Spin>
  )
}

export default StepThree;